import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { label: "홈", path: "/" },
  { label: "클래스", path: "/explore" },
  { label: "로드맵", path: "/roadmap" },
  { label: "피드", path: "/feed" },
  { label: "커뮤니티", path: "/community" },
  { label: "요금제", path: "/pricing" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-white border-b border-[#F2F4F6]"
          : "bg-transparent"
      }`}
      style={{ height: "64px" }}
    >
      <div className="max-w-6xl mx-auto px-6 h-full flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/e5c5971dbaa3883665c34cea4172400b/b1c3cef8a5b787f4827004da87a9c36d.png"
            alt="GrowSeo Logo"
            className="h-8 w-auto object-contain"
          />
          <span
            className={`font-extrabold text-lg tracking-tight transition-colors duration-300 ${
              scrolled || !isHome ? "text-[#191F28]" : "text-[#191F28]"
            }`}
          >
            GrowSeo
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === item.path
                  ? "text-[#00D873]"
                  : "text-[#191F28] hover:text-[#00D873]"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        {/* Right Side */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/notebook"
            title="프롬프트 노트북"
            className={`w-9 h-9 flex items-center justify-center rounded-xl transition-colors ${location.pathname === "/notebook" ? "bg-[#00D873]/10 text-[#00D873]" : "text-[#191F28]/50 hover:text-[#191F28] hover:bg-[#F2F4F6]"}`}
          >
            <i className="ri-book-open-line text-lg" />
          </Link>
          <Link
            to="/portfolio"
            title="내 포트폴리오"
            className={`w-9 h-9 flex items-center justify-center rounded-xl transition-colors ${location.pathname === "/portfolio" ? "bg-[#00D873]/10 text-[#00D873]" : "text-[#191F28]/50 hover:text-[#191F28] hover:bg-[#F2F4F6]"}`}
          >
            <i className="ri-user-star-line text-lg" />
          </Link>
          <Link
            to="/journal"
            title="성찰 일지"
            className={`w-9 h-9 flex items-center justify-center rounded-xl transition-colors ${location.pathname === "/journal" ? "bg-[#00D873]/10 text-[#00D873]" : "text-[#191F28]/50 hover:text-[#191F28] hover:bg-[#F2F4F6]"}`}
          >
            <i className="ri-mental-health-line text-lg" />
          </Link>
          <button className="text-sm font-medium text-[#191F28] hover:text-[#00D873] transition-colors whitespace-nowrap cursor-pointer">
            로그인
          </button>
          <Link
            to="/dashboard"
            className="bg-[#00D873] text-white text-sm font-bold px-5 py-2.5 rounded-full hover:opacity-90 transition-all duration-200 hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
          >
            시작하기
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="메뉴"
        >
          <i className={`text-[#191F28] text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#F2F4F6] px-6 pb-4">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`block py-3 text-sm font-medium transition-colors ${
                location.pathname === item.path ? "text-[#00D873]" : "text-[#191F28]"
              }`}
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/dashboard"
            className="mt-3 w-full bg-[#00D873] text-white text-sm font-bold py-3 rounded-full block text-center cursor-pointer whitespace-nowrap"
            onClick={() => setMenuOpen(false)}
          >
            시작하기
          </Link>
        </div>
      )}
    </header>
  );
}
